import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\CheckEnaosCredentialController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/CheckEnaosCredentialController.php
* @route '/api/partner/enaos/check-credentials'
*/
const CheckEnaosCredentialController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckEnaosCredentialController.url(options),
    method: 'get',
})

CheckEnaosCredentialController.definition = {
    methods: ["get","head"],
    url: '/api/partner/enaos/check-credentials',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\CheckEnaosCredentialController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/CheckEnaosCredentialController.php
* @route '/api/partner/enaos/check-credentials'
*/
CheckEnaosCredentialController.url = (options?: RouteQueryOptions) => {
    return CheckEnaosCredentialController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\CheckEnaosCredentialController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/CheckEnaosCredentialController.php
* @route '/api/partner/enaos/check-credentials'
*/
CheckEnaosCredentialController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckEnaosCredentialController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\CheckEnaosCredentialController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/CheckEnaosCredentialController.php
* @route '/api/partner/enaos/check-credentials'
*/
CheckEnaosCredentialController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CheckEnaosCredentialController.url(options),
    method: 'head',
})

export default CheckEnaosCredentialController